export const NAV_SECTIONS = {
  top: [
    { label: "Home", to: "/#hero" },
    { 
      label: "Off-Market Properties", 
      to: "/offmarket-properties", 
      badge: "HOT" 
    },
  ],

  explore: [
    { label: "Who We Help", to: "/#help" },
    { label: "Our Process", to: "/#process" },
    { label: "Why Us", to: "/#why" },
    { label: "Case Studies", to: "/case-studies" },
    { label: "About Us", to: "/about" },
  ],

  tools: [
    { label: "Cashflow Calculator", to: "/cashflow-calculator" },
    { label: "Strategy Simulator", to: "/strategy" },
    { label: "Find Properties", to: "/submit-brief" }, // label changed
  ],

  account: {
    loggedOut: [
      { label: "Login", to: "/login" },
      { label: "Join Now", to: "/join", highlight: true },
    ],
    loggedIn: [
      { label: "My Profile", to: "/dashboard" },
      { label: "Logout", action: "logout", danger: true },
    ],
  },
};
